import { fetchGet } from "@/lib/services";

export async function getSubscriptionSummary(branchCode?: string) {
  const url = branchCode
    ? `/subscriptiondata/?Branch_Code=${branchCode}`
    : `/subscriptiondata/`;

  return await fetchGet(url);
}

export async function getSubscriptionDetail(
  branchCode?: string,
  activePage = 1,
  expiringPage = 1,
  expiredPage = 1,
  readyPage = 1
) {
  const params = new URLSearchParams();

  if (branchCode) {
    params.append("Branch_Code", branchCode);
  }

  params.append("subscriptiondata", "true");
  params.append("page_size", "20");
  params.append("active_page", String(activePage));
  params.append("expiring_page", String(expiringPage));
  params.append("expired_page", String(expiredPage));
  params.append("ready_page", String(readyPage));

  return await fetchGet(`/subscriptiondata/?${params.toString()}`);
}